<template>
  <div :id="componentId" class="sp6-cultivation-section" :style="{ backgroundColor: bgColor }">
    <div class="sp6-block_12 flex-col">
      <div class="sp6-group_17 flex-row justify-between">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="sp6-image-text_13 flex-col justify-between"
        >
          <img
            v-if="item.imageUrl"
            class="sp6-image_11 sp6-cultivation-image"
            referrerpolicy="no-referrer"
            :src="item.imageUrl"
            @click="goTo(item.url)"
          />
          <div class="sp6-text-group_13 flex-col justify-between">
            <span class="sp6-text_48" @click="goTo(item.url)">{{ item.title }}</span>
            <span class="sp6-paragraph_1">
              <span
                v-for="(sub, subIndex) in item.itemList"
                :key="subIndex"
                class="sp6-cultivation-item"
                @click="goTo(sub.url)"
              >
                {{ sub.title }}
                <br v-if="subIndex < item.itemList.length - 1" />
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CultivationSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_5'
    }
  },
  data() {
    return {
      bgColor: 'rgba(230, 236, 247, 1)',
      list: [
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNG550c781bed908837d190f0172606bf4b.png'),
          title: '主题：习近平经济思想与品牌',
          itemList: [
            { title: '十四届全国人大一次会议在京闭幕 习近平发...', url: '' },
            { title: '十四届全国人大一次会议举行第五次全体会议...', url: '' },
            { title: '全国政协十四届一次会议闭幕', url: '' },
            { title: '十四届全国人大一次会议举行第四次全体会议...', url: '' }
          ],
          url: ''
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNG550c781bed908837d190f0172606bf4b.png'),
          title: '主题：习近平经济思想与品牌',
          itemList: [
            { title: '十四届全国人大一次会议在京闭幕 习近平发...', url: '' },
            { title: '十四届全国人大一次会议举行第五次全体会议...', url: '' },
            { title: '全国政协十四届一次会议闭幕', url: '' },
            { title: '十四届全国人大一次会议举行第四次全体会议...', url: '' }
          ],
          url: ''
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNG550c781bed908837d190f0172606bf4b.png'),
          title: '主题：习近平经济思想与品牌',
          itemList: [
            { title: '十四届全国人大一次会议在京闭幕 习近平发...', url: '' },
            { title: '十四届全国人大一次会议举行第五次全体会议...', url: '' },
            { title: '全国政协十四届一次会议闭幕', url: '' },
            { title: '十四届全国人大一次会议举行第四次全体会议...', url: '' }
          ],
          url: ''
        }
      ]
    };
  },
  methods: {
    goTo(url) {
      if (!url) return;
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped>
.sp6-cultivation-section {
  position: relative;
  width: 2000px;
  left: 50%;
  transform: translateX(-50%);
}

.sp6-block_12 {
  position: relative;
  width: 1400px;
  margin: 0 auto;
  background: none;
}

.sp6-cultivation-section .sp6-group_17 {
  width: 1400px !important;
  height: auto !important;
  margin: 20px 0 !important;
  gap: 31px;
}

.sp6-cultivation-section .sp6-image-text_13 {
  width: 446px !important;
  height: auto !important;
}

.sp6-cultivation-section .sp6-image_11 {
  width: 446px !important;
  height: 250px;
}

.sp6-cultivation-section .sp6-text-group_13 {
  width: 446px !important;
  height: auto !important;
  margin-top: 14px;
}

.sp6-cultivation-section .sp6-text_48 {
  width: 446px !important;
  height: auto !important;
  text-align: center;
  white-space: normal;
  overflow-wrap: break-word;
  padding: 0 10px;
}

.sp6-cultivation-section .sp6-paragraph_1 {
  width: 446px !important;
  height: auto !important;
  text-align: left;
  line-height: 28px;
  margin-top: 14px;
  padding: 0 10px;
}

.sp6-cultivation-image {
  cursor: pointer;
}

.sp6-cultivation-item {
  cursor: pointer;
}

.cultivation-item-card {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
  background: #f9f9f9;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
}

.item-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.sub-item-row {
  margin-bottom: 15px;
  padding: 10px;
  background: #fff;
  border-radius: 4px;
}
</style>